import { createSlice } from "@reduxjs/toolkit";
import { FetchStatus } from "../../shared/redux.consts";
import {
  DirectIncomesState,
  DirectIncomesStore,
} from "../../types/direct-incomes";
import {
  fetchGetCategorisedDirectIncomes,
  fetchGetDirectIncomes,
} from "./direct-incomes.thunk";

const initialDirectIncomesState: DirectIncomesState = {
  directIncomes: [],
  getStatus: FetchStatus.IDLE,
  categorisedDirectIncomes: [],
  categorisedGetStatus: FetchStatus.IDLE,
};

export const directIncomesSlice = createSlice({
  name: "directIncomes",
  initialState: initialDirectIncomesState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetDirectIncomes.pending, (state) => {
        state.getStatus = FetchStatus.LOADING;
        state.getError = undefined;
      })
      .addCase(fetchGetDirectIncomes.fulfilled, (state, action) => {
        state.getStatus = FetchStatus.SUCCESS;
        state.directIncomes = action.payload ?? [];
      })
      .addCase(fetchGetDirectIncomes.rejected, (state, action) => {
        state.getStatus = FetchStatus.FAILED;
        if (action.error?.message !== undefined) {
          state.getError = action.error.message;
        }
      })
      .addCase(fetchGetCategorisedDirectIncomes.pending, (state) => {
        state.categorisedGetStatus = FetchStatus.LOADING;
        state.categorisedGetError = undefined;
      })
      .addCase(fetchGetCategorisedDirectIncomes.fulfilled, (state, action) => {
        state.categorisedGetStatus = FetchStatus.SUCCESS;
        state.categorisedDirectIncomes = action.payload ?? [];
      })
      .addCase(fetchGetCategorisedDirectIncomes.rejected, (state, action) => {
        state.categorisedGetStatus = FetchStatus.FAILED;
        if (action.error?.message !== undefined) {
          state.categorisedGetError = action.error.message;
        }
      });
  },
});

export const selectDirectIncomesState = (store: DirectIncomesStore) =>
  store.directIncomesState;

export default directIncomesSlice.reducer;
